import AuthService from '@/shared/services/AuthService';
import angular from 'angular';
import moment from 'moment';

angular
  .module('cxSettings')
  .controller('TaskScheduleDialogCtrl', [
    '$http',
    '$q',
    '$timeout',
    'appUrls',
    'settingsDialogsSvc',
    'flySvc',
    'dialogsSvc',
    'checkFeature',
    '$translate',
    '$element',
    '$scope',
    'close',
    'taskTemplateId',
    'ModalService',
    'enumCacheSvc',
    'translateListFilter',
    taskScheduleDialogCtrl,
  ]);
function taskScheduleDialogCtrl(
  $http,
  $q,
  $timeout,
  appUrls,
  settingsDialogsSvc,
  flySvc,
  dialogsSvc,
  checkFeature,
  $translate,
  $element,
  $scope,
  close,
  taskTemplateId,
  ModalService,
  enumCacheSvc,
  translateListFilter,
) {
  const vm = this;
  vm.schedules = [];
  vm.loading = true;
  vm.dayMonthOptions = {
    minMode: 'day',
    maxMode: 'month',
    showWeeks: false,
    formatDayTitle: 'MMMM',
    datepickerMode: 'month',
    formatMonthTitle: ' ',
    initDate: moment
      .utc()
      .startOf('day')
      .set({
        year: 2000,
      })
      .toDate(),
    // minDate: new Date(2000, 0, 1),
    // maxDate: new Date(2000, 11, 31),
  };
  vm.datepickerOptions = {
    startingDay: 1,
  };
  vm.planningButtonDisabled = false;

  enumCacheSvc.get('periodicitylinetype').then(function(data) {
    // devops #20846, filter out "fixed/eenmalige planningen"
    vm.lineTypes = data
      .filter(x => x.key !== 1)
      .map(item => ({
        ...item,
        label: translateListFilter(item.key, 'periodicitylinetype', item.value),
      }));
  });

  const lang = $translate.use().split('-')[0];
  vm.fodUrl =
    lang === 'nl'
      ? 'https://financien.belgium.be/nl/E-services/biztax/indieningstermijnen-aangiften'
      : lang === 'fr'
      ? 'https://finances.belgium.be/fr/E-services/biztax/delais-de-rentree-des-declarations'
      : null;

  const mapLine = function(line) {
    if (!line) return line;
    if (line.date && typeof line.date === 'string') line.date = new Date(line.date.substr(0, 10));
    if (line.planningDate && typeof line.planningDate === 'string')
      line.planningDate = new Date(line.planningDate.substr(0, 10));

    return line;
  };
  const mapSchedule = function(schedule) {
    if (!schedule.lines) schedule.lines = [];
    schedule.lines = schedule.lines.map(mapLine);
    return schedule;
  };

  vm.getAllowedLineTypes = schedule => {
    if (!vm.lineTypes) return [];

    if (!schedule || !schedule.lines || schedule.lines.length <= 1) return vm.lineTypes;

    if (schedule.lines.some(x => x.type === 10)) {
      return vm.lineTypes.filter(x => x.key === 10);
    }
    return vm.lineTypes.filter(x => x.key !== 10);
  };

  $http.get(appUrls.tasks + '/api/taskperiodicity/' + taskTemplateId).then(function(response) {
    vm.schedules = response.data.map(mapSchedule);
    if (vm.schedules.length < 3) {
      vm.schedules.forEach(x => (x.showDetails = true));
    }
    vm.loading = false;
  });

  vm.toggleDetails = function(schedule) {
    schedule.showDetails = !schedule.showDetails;
  };

  vm.calcPlanningDate = function(schedule, line) {
    if (!schedule || !line || !line.date || line.type >= 2) return null;

    var date = line.date;
    if (typeof date === 'string') date = new moment(date.substr(0, 10)).toDate();
    else date = new Date(date.getTime()); //Create copy

    date.setDate(date.getDate() - (schedule.planningDeviation || 0));
    if (line.type === 0) {
      date.setFullYear(2000);
    }
    return date;
  };

  vm.duplicate = function(schedule) {
    if (schedule && schedule.lines && schedule.lines.some(l => l.type === 1)) {
      flySvc.error(1042, null, null, 'TaskDomainExceptionCode');
      return;
    }

    settingsDialogsSvc.copyTaskSchedule(schedule).then(function(result) {
      if (result) {
        var idx = vm.schedules.indexOf(schedule);
        if (idx >= 0) {
          vm.schedules.splice(idx + 1, 0, result);
        } else {
          vm.schedules.push(result);
          vm.schedules = vm.schedules.sortByProperty('name');
        }
      }
    });
  };

  vm.remove = function(schedule) {
    if (!schedule || !schedule.id || schedule.isLocked) return;
    $http
      .get(appUrls.tasks + '/api/TaskPeriodicity/PeriodicityInUse/' + schedule.id)
      .then(function({ data }) {
        if (data && data.length) {
          // cant delete periodicity while its used by schedules
          ModalService.showModal({
            template: require('./relationsUsingTaskPeriodicityDialog.html'),
            controller: 'RelationsUsingTaskPeriodicityDialogCtrl',
            controllerAs: 'vm',
            locationChangeSuccess: false,
            inputs: {
              relations: data,
            },
          }).then(function(modal) {
            modal.element.modal();
            modal.element.on('hidden.bs.modal', function(e) {
              modal.element.off(e); //Remove event
              modal.element.remove(); //Remove element
            });
          });
        } else {
          dialogsSvc
            .showYesNo('msgConfirmDeleteTitle', 'msgConfirmDeleteTaskSchedule')
            .then(function() {
              $http.delete(appUrls.tasks + '/api/TaskPeriodicity/' + schedule.id).then(function() {
                var idx = vm.schedules.indexOf(schedule);
                if (idx >= 0) vm.schedules.splice(idx, 1);
              });
            });
        }
      });
  };

  vm.update = function(schedule, data, field) {
    if (field === 'planningDeviation' && !data) data = 0;
    if (schedule[field] === data) return false;
    var model = angular.copy(schedule);
    model[field] = data;

    delete model.lines;
    return $http.put(appUrls.tasks + '/api/TaskPeriodicity/', model).then(
      function(response) {
        if (response && response.data) {
          angular.extend(schedule, mapSchedule(response.data));
        }
        flySvc.success();
        return false;
      },
      function(error) {
        flySvc.error(error);
        return '';
      },
    );
  };

  vm.updateLine = function(schedule, line, data, field) {
    if (!line.id) return true; // =New lines
    if (typeof data === 'undefined') return ''; //Validation error
    if (line[field] === data) return false;

    if (field === 'date' && (line.type === 0 || line.type === 1) && !data) {
      return ' ';
    }
    var model = angular.copy(line);
    model[field] = data;

    if (field === 'type' && data === 1 && model.date) {
      if (model.date.getFullYear() <= 2000) {
        var now = new Date();
        model.date.setFullYear(now.getFullYear());
        if (model.date < now) model.date.setFullYear(now.getFullYear() + 1);
      }
    }

    if (model.date && model.date instanceof Date) model.date = moment.utc(model.date);
    if (model.planningDate && model.planningDate instanceof Date)
      model.planningDate = moment.utc(model.planningDate);

    return $http.put(appUrls.tasks + '/api/TaskPeriodicity/Lines', model).then(
      function(response) {
        if (response && response.data) angular.extend(line, mapLine(response.data));

        if (line.type === 10) {
          schedule.cleanupMonths = 12; //This was already updated in the backend (but it's not in the response)
        }
        flySvc.success();
        return false;
      },
      function(error) {
        flySvc.error(
          error.data ? error.data.code : null,
          error.data ? error.data.parameters : null,
          null,
          error.data ? error.data.type : null,
        );
        return '';
      },
    );
  };
  var deleteLineCall = function(schedule, line, deleteTasks = false) {
    return $http
      .delete(`${appUrls.tasks}/api/TaskPeriodicity/Lines/${line.id}`, {
        params: {
          deleteTasks,
        },
      })
      .then(
        function() {
          var idx = schedule.lines.indexOf(line);
          if (idx >= 0) schedule.lines.splice(idx, 1);
          flySvc.success();
        },
        function(error) {
          flySvc.error(error);
          return '';
        },
      );
  };

  vm.removeLine = function(schedule, line) {
    if (!schedule || !schedule.id || schedule.isLocked) return;
    if (!line.id) {
      // =New line
      var idx = schedule.lines.indexOf(line);
      if (idx >= 0) schedule.lines.splice(idx, 1);
    } else {
      $http
        .get(appUrls.tasks + '/api/TaskPeriodicity/PeriodicityInUse/' + schedule.id)
        .then(function({ data }) {
          if (data && data.length) {
            // cant delete periodicity line while periodicty is used by schedules on relations
            ModalService.showModal({
              template: require('./deleteTaskPeriodicityLineDialog.html'),
              controller: 'DeleteTaskPeriodicityLineDialogCtrl',
              controllerAs: 'vm',
              locationChangeSuccess: false,
              inputs: {
                relations: data,
              },
            }).then(function(modal) {
              modal.element.modal();
              modal.element.on('hidden.bs.modal', function(e) {
                modal.element.off(e); //Remove event
                modal.element.remove(); //Remove element
              });
              modal.close.then(function(deleteTasks) {
                if (deleteTasks === null) return;

                deleteLineCall(schedule, line, deleteTasks);
              });
            });
          } else {
            dialogsSvc
              .showYesNo('msgConfirmDeleteTitle', 'msgConfirmDeleteTaskScheduleLine')
              .then(function() {
                deleteLineCall(schedule, line, false);
              });
          }
        });
    }
  };

  vm.addNewLine = function(schedule) {
    var type = 0;
    var date = null;
    if (schedule.lines) {
      if (schedule.lines.length) {
        type = schedule.lines[schedule.lines.length - 1].type;
      }
      if (schedule.lines.length >= 2) {
        var date1 = schedule.lines[schedule.lines.length - 2].date;
        var date2 = schedule.lines[schedule.lines.length - 1].date;
        if (date1 && date2) {
          date = new Date(date2.getTime() + (date2 - date1));
        }
      }
    }
    if (type === 1) type = 0;
    var line = {
      type,
      date: date ? date.ISO() : null,
      planningDate: null,
      deviation: 0,
    };
    line.saving = true;
    $http
      .post(appUrls.tasks + '/api/TaskPeriodicity/Lines/' + schedule.id, line)
      .then(
        function(response) {
          if (response && response.data) schedule.lines.push(mapLine(response.data));
          flySvc.success();
          return false;
        },
        function(error) {
          flySvc.error(error);
          return '';
        },
      )
      .finally(function() {
        line.saving = false;
      });
  };

  vm.addSchedule = function() {
    settingsDialogsSvc.addTaskSchedule(taskTemplateId).then(function(result) {
      if (result) {
        var schedule = mapSchedule(result);
        schedule.showDetails = true;
        vm.schedules.push(schedule);
      }
    });
  };

  vm.translateSchedule = function(schedule) {
    dialogsSvc
      .translateListItem('taskperiodicity', schedule.id, schedule.name, { maxlength: 500 })
      .then(function(result) {
        if (result && result.defaultValue) {
          vm.update(schedule, result.defaultValue, 'name');
        }
      });
  };
  vm.getPlanningDateOptions = function(orgOptions, schedule, line) {
    var options = angular.extend({}, orgOptions);
    if (!line.planningDate) {
      const planningDate = vm.calcPlanningDate(schedule, line);
      if (planningDate) {
        options.initDate = new moment(planningDate).toDate();
        if (options.initDate) options.datepickerMode = 'day';
      }
    }
    return options;
  };
  vm.planTasks = function() {
    vm.planningButtonDisabled = true;
    $http.post(appUrls.tasks + '/api/TaskTemplates/Plan/' + taskTemplateId).then(
      function(response) {
        if (response && response.data) {
          flySvc.success('msgTaskPlanningXSchedulesQueued', { count: response.data });
        } else {
          flySvc.message('msgTaskPlanningNothingQueued');
        }
        return false;
      },
      function(error) {
        flySvc.error(error);
        return '';
      },
    );
  };
  vm.getCleanupMonthsLabel = months => {
    if (!months) return $translate.instant('NoCleanup');
    if (months === 12) return `1 ${$translate.instant('year')}`;
    if (months % 12 === 0) return `${months / 12} ${$translate.instant('years')}`;
    if (months === 1) return `1 ${$translate.instant('month')}`;
    return `${months} ${$translate.instant('months')}`;
  };
  vm.getCleanupMonthsLabelForColumn = months => {
    const label = vm.getCleanupMonthsLabel(months);
    if (!months) return label;
    return $translate.instant('Cleanup after {{value}} after deadline', { value: label });
  };
  vm.getCleanupMonthOptions = schedule => {
    if (schedule.lines.some(x => x.type === 10)) return [12];
    return [null, 12, 24, 36, 48, 60];
  };
  vm.updateCleanupMonths = (schedule, months) => {
    if (schedule.cleanupMonths === months) return false;
    if (!months) return vm.update(schedule, null, 'cleanupMonths');

    //Get delete count
    return $http
      .get(appUrls.tasks + '/api/PlannedTasks/CleanupCount/' + schedule.id, {
        params: {
          months,
        },
      })
      .then(
        ({ data: count = 0 } = {}) => {
          if (count > 0) {
            //The count is limited to 1001 in the backend to make the query faster
            const msg =
              count > 1000 ? 'msgConfirmCleanupMonthsAtLeast1000' : 'msgConfirmCleanupMonths';

            return dialogsSvc
              .showYesNo('msgConfirmCleanupMonthsTitle', msg, {
                count,
                value: vm.getCleanupMonthsLabel(months),
              })
              .then(
                () => vm.update(schedule, months, 'cleanupMonths'), //Yes, do update
                () => false, //No, cancel
              );
          }

          return vm.update(schedule, months, 'cleanupMonths');
        },
        function(error) {
          flySvc.error(error);
          return '';
        },
      );
  };

  vm.cancel = function() {
    close({ count: vm.schedules.length }, 500);
  };

  vm.showReferenceYear = schedule => {
    if (!AuthService.hasFeature('ReferenceYear')) return false;

    if (schedule) {
      return schedule.lines.some(x => x.type === 0);
    } else {
      for (var i = 0; i < vm.schedules.length; i++) {
        schedule = vm.schedules[i];
        const hasYearlyScheduleLine = schedule.lines.some(x => x.type === 0);
        if (hasYearlyScheduleLine) return true;
      }
    }

    return false;
  };
  vm.showReferenceYearOnLine = line => {
    // only show on yearly schedules
    return AuthService.hasFeature('ReferenceYear') && line.type === 0;
  };

  vm.referenceYearTypePlaceholder = schedule => {
    if (!schedule.referenceYearType) return '';

    return `${translateListFilter(
      schedule.referenceYearType,
      'taskReferenceYearType',
      schedule.referenceYearType,
    )} (${$translate.instant('GeneralSetting')})`;
  };
}
